import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface AnimatedCountProps {
  count: number;
  className?: string;
  suffix?: (count: number) => string;
}

export function AnimatedCount({
  count,
  className,
  suffix,
}: AnimatedCountProps) {
  const [displayCount, setDisplayCount] = useState(count);
  const [isAnimating, setIsAnimating] = useState(false);
  const prevCountRef = useRef(count);

  useEffect(() => {
    if (count !== prevCountRef.current) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setDisplayCount(count);
        setIsAnimating(false);
      }, 150);

      prevCountRef.current = count;
      return () => clearTimeout(timer);
    }
  }, [count]);

  const suffixText = suffix ? suffix(displayCount) : "";

  return (
    <span className={cn("relative inline-block", className)}>
      <span
        className={cn(
          "transition-all duration-300",
          isAnimating && "scale-110 text-orange-500"
        )}
      >
        {displayCount}
      </span>
      {suffixText && <span className="ml-1">{suffixText}</span>}
    </span>
  );
}
